import React from 'react';

import './styles.scss';

class Button extends React.Component {
    render() {
        return (
            <button
                type={`${this.props.submit ? 'submit' : 'button'}`}
                disabled={!!this.props.disabled}
                className={`button ${this.props.class}`}
                onClick={this.props.onClick}
                data-xray-click={this.props.xray}
            >
                { this.props.name }
            </button>
        )
    }
}

export default Button;
